class DropdownController extends HTMLElement {
  static get observedAttributes() {
    return ['aria-active'];
  }

  constructor() {
    super();
    this.dropdownButton = null;
    this.dropdownButtonId = null;
    this.dropdownContainerId = null;
    this.dropdownContainer = null;

    this.onSelfClick = this.onSelfClick.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  connectedCallback() {
    this.dropdownButtonId = this.getAttribute('dropdownButtonId');
    this.dropdownContainerId = this.getAttribute('dropdownContainerId');
    this.dropdownButton = document.getElementById(this.dropdownButtonId);
    this.dropdownContainer = document.getElementById(this.dropdownContainerId);

    this.addEventListener('click', this.onSelfClick);
    this.addEventListener('keyup', this.onKeyUp);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onSelfClick);
    this.removeEventListener('keyup', this.onKeyUp);
    document.removeEventListener('click', this.onDocumentClick);
  }

  onSelfClick(e) {
    if (!this.dropdownButton) return;
    if (e.target.closest('button') !== this.dropdownButton) return;
    
    e.stopPropagation();
    const isPressed = this.dropdownButton.getAttribute('aria-pressed') === 'true';
    this.setState(!isPressed);
  }

  onKeyUp(e) {
    if (e.key === 'Escape' && this.dropdownButton) this.setState(false);
  }

  onDocumentClick(e) {
    if (!this.contains(e.target) && this.dropdownButton) this.setState(false);
  }

  setState(isActive) {
    if (!this.dropdownButton) return;
    this.dropdownButton.setAttribute('aria-pressed', isActive);
    this.setAttribute('aria-active', isActive);
  }
}

customElements.define('dropdown-controller', DropdownController);
